.ef{gap:0.375rem;}